export enum PatientFormMode {
    CreateNewPatient = 'createNewPatient',
    EditPatient = 'editPatient'
}
